import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Api from "../../utils/api";
import DownloadFile from "../../utils/downloadFile";
import { setRoute } from "../../store/actions/routeActions";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/Button";
import { SkeletonTable } from "../../components/Skeleton";
import {
  faChevronDown,
  faFilePdf,
  faPrint,
  faCreditCard,
} from "@fortawesome/free-solid-svg-icons";
import "./CuotasYPago.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ImageRapiPago from "../../assets/images/pagos/rp.png";
import ImagePagoMisCuentas from "../../assets/images/pagos/pmc.png";
import ImageProvinciaNet from "../../assets/images/pagos/pn.png";
import ModalMediosPago from "../../components/serviciosIndividuales/ModalMediosPago";
import ModalInformarPago from "../../components/serviciosIndividuales/ModalInformarPago";
import { RootState } from "../../store/reducers";
import IPrefPasajeros from "../../interfaces/IPrefPasajeros";
import usePagoOnline from "../../hooks/usePagoOnline.hook";
import IModalidadPago from "../../interfaces/IModalidadPago";
import PromoBanner from "../../components/PromoBanner";
import BarraPagoFlotante from "../../components/BarraPagoFlotante";

interface ICuota {
  show: boolean;
  onImprimirFactura: boolean;
  BOTON_ACTUALIZAR: boolean;
  CLAVE_EMISION: string;
  CONCEPTO: string;
  D_IMPORTE: string;
  D_IMPORTE2: string;
  D_PAGO: boolean;
  D_PRI_VEN: string;
  D_SEG_VEN: string;
  D_SEN: string;
  D_VENCIDO: boolean;
  IMP_PAGAR: string;
  IMP_TRANSFERIR: number;
  MONEDA: string;
  NU_FACTURA: string;
  NU_TALON: string;
  mensaje?: string;
}

export default function CuotasYPago() {
  const [cuotaInformarPago, setCuotaInformarPago] = useState<ICuota | null>(
    null
  );
  const navigate = useNavigate();
  const [generarPlan, setGenerarPlan] = useState<{
    message: string;
    show: boolean;
    date: string[];
  }>({
    message: "",
    show: false,
    date: ["", "", ""],
  });
  const pasajeros = useSelector((state: RootState) => state.pasajeros);
  const [importePagar, setImportePagar] = useState<number>(0);
  const [cuotas, setCuotas] = useState<Array<ICuota>>([]);
  const [cuotasFilter, setCuotasFilter] = useState<Array<ICuota>>([]);
  const [optionFilter, setOptionFilter] = useState("pagadas");
  const [cuotasPagar, setCuotasPagar] = useState<
    Array<{ NU_TALON: string; IMP_PAGAR: number }>
  >([]);
  const [showMetodoPago, setShowMetodoPago] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [onLoad, setOnLoad] = useState(true);
  const [pasajero, setPasajero] = useState<IPrefPasajeros | null>(null);
  const [showBanner, setShowBanner] = useState(false);

  const pago = usePagoOnline();

  const { id = "-1", nombre = "" } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    setPasajero(pasajeros.pasajeros.find((p) => p.CO_PASAJERO === id) || null);
  }, [id, pasajeros]);

  useEffect(() => {
    dispatch(
      setRoute({
        section: "pasajero",
        sub: "cuotas-y-pago",
        cp: id,
      })
    );
  }, [dispatch, id]);

  useEffect(() => {
    setOnLoad(true);
    Api("consumir")
      .post({
        servicio: "paxCuotas",
        param: {
          pco_pasajero: id,
        },
      })
      .then((res) => {
        setOnLoad(false);
        setShowBanner(res.PM_BANNER_PROMO === "S");
        const prefGenPlan = res.PREF_GENPLAN?.[0];
        if (prefGenPlan) {
          const fechahasta = res.PF_PC_HASTA.match(/^(\d+)\/(\d+)\/(\d+)$/);
          setGenerarPlan({
            message: prefGenPlan.MENSAJE,
            show: prefGenPlan.M_GENERAR_PLAN === "S",
            date: fechahasta,
          });
        }

        const _cuotas = res.PREF_CUOTAS.map((cuota: any) => ({
          show: false,
          BOTON_ACTUALIZAR: cuota.BOTON_ACTUALIZAR === "S",
          CLAVE_EMISION: cuota.CLAVE_EMISION,
          CONCEPTO: cuota.CONCEPTO,
          D_IMPORTE: cuota.D_IMPORTE,
          D_IMPORTE2: cuota.D_IMPORTE2,
          D_PAGO: cuota.D_PAGO === "X",
          D_PRI_VEN: cuota.D_PRI_VEN,
          D_SEG_VEN: cuota.D_SEG_VEN,
          D_SEN: cuota.D_SEN,
          D_VENCIDO: cuota.D_VENCIDO === "X",
          IMP_PAGAR: cuota.IMP_PAGAR,
          IMP_TRANSFERIR: +cuota.IMP_TRANSFERIR,
          MONEDA: cuota.MONEDA,
          NU_FACTURA: cuota.NU_FACTURA,
          NU_TALON: cuota.NU_TALON,
          onImprimirCuota: false,
          mensaje: cuota.MENSAJE || "",
        }));
        setCuotas(_cuotas);
        /**
         * verificamos si hay cuotas pendientes, ya que si no hay, mostramos
         * todas las cuotas para que no aparezca la lista vacia
         */
        if (_cuotas.some((e: any) => !e.D_PAGO)) {
          setOptionFilter("pendientes");
        }
      });
  }, [id]);

  useEffect(() => {
    switch (optionFilter) {
      case "pagadas":
        setCuotasFilter(cuotas.filter((e) => e.D_PAGO));
        break;
      case "pendientes":
        setCuotasFilter(cuotas.filter((e) => !e.D_PAGO));
        break;
      default:
      case "todas":
        setCuotasFilter(cuotas);
        break;
    }
  }, [optionFilter, cuotas]);

  function handleChangeFilter(e: React.ChangeEvent<HTMLSelectElement>) {
    setOptionFilter(e.target.value);
  }

  function handleTogleCuota(e: React.ChangeEvent<HTMLInputElement>) {
    const talon: string = e.target.name;
    const cuotaFinded = cuotas.find((e) => e.NU_TALON === talon);
    if (!cuotaFinded) return;
    if (e.target.checked) {
      setCuotasPagar([
        ...cuotasPagar,
        { NU_TALON: cuotaFinded.NU_TALON, IMP_PAGAR: +cuotaFinded.IMP_PAGAR },
      ]);
      return;
    }
    setCuotasPagar(cuotasPagar.filter((cuota) => cuota.NU_TALON !== talon));
  }

  useEffect(() => {
    let total: number = 0;
    for (const cuotaPagar of cuotasPagar) {
      total += Number(cuotaPagar.IMP_PAGAR);
    }
    setImportePagar(total);
  }, [cuotasPagar]);

  function handleClickImprimir(talon: string) {
    setPrinting(true);
    Api("birt")
      .post({
        reporte: "SV_cuota.rptdesign",
        param: {
          prm_co_pasajero: id,
          prm_nu_talon: talon.toString(),
        },
      })
      .then((res) => {
        DownloadFile(res.reporte_base64, `${id} - Talon ${talon}`);
      })
      .finally(() => {
        setPrinting(false);
      });
  }

  // Abre el modal y pide las modalidades de pago disponibles.
  const handleAbrirMedios = () => {
    const ptalones = cuotasPagar.map((c) => c.NU_TALON).join(",");
    setShowMetodoPago(true);
    pago.fetchModalidades({
      prm_co_pasajero: id,
      prm_talones: ptalones,
      prm_importe_ctl: importePagar,
      urls: {
        url_success: window.location.origin + "/pagoResultado",
        url_cancel:
          window.location.origin +
          `/pasajero/${id}/${nombre}/cuotas`,
        url_redirect: window.location.origin + "/pagoResultado",
      },
    });
  };

  // Elegida la opción, inicia el pago y redirige a la recaudadora.
  const handleSelectModalidad = async (modalidad: IModalidadPago) => {
    const url = await pago.iniciarPago(modalidad);
    if (url) {
      window.location.href = url;
    }
  };

  const handleCerrarMedios = () => {
    setShowMetodoPago(false);
    pago.reset();
  };

  const handleClickImprimirFactura = (factura: string) => {
    let _cuotas = cuotas.map((cuota: ICuota) => {
      if (cuota.NU_FACTURA === factura) {
        cuota.onImprimirFactura = true;
      }
      return cuota;
    });

    setCuotas(_cuotas);

    Api("consumir")
      .post({
        servicio: "facturaPDF",
        param: {
          pnu_factura: factura,
          pco_pasajero: id,
        },
      })
      .then((res) => {
        DownloadFile(
          res.PREF_FACTURA[0].PDF_BASE64,
          `${id} - Factura ${factura}`
        );
      })
      .finally(() => {
        let _cuotas = cuotas.map((cuota: ICuota) => {
          if (cuota.NU_FACTURA === factura) {
            cuota.onImprimirFactura = false;
          }
          return cuota;
        });

        setCuotas(_cuotas);
      });
  };

  const showCuota = (nutalon: string) => {
    const solicitud = cuotas.findIndex((e) => e.NU_TALON === nutalon);
    let _cuotas = [...cuotas];
    _cuotas[solicitud].show = !_cuotas[solicitud].show;
    setCuotas(_cuotas);
  };

  return (
    <div className="container-data">
      {generarPlan.show && (
        <div className="alert alert-secondary text-center">
          <p dangerouslySetInnerHTML={{ __html: generarPlan.message }}></p>
          <Button
            title="Confeccionar mi plan de Pago"
            onPress={() =>
              navigate(
                `/pasajero/${id}/${nombre
                  .replace("*", "")
                  .replaceAll(" ", "-")}/confeccionar-plan`
              )
            }
          />
        </div>
      )}
      {pasajero?.CO_MONEDA === "1" ? (
        <div className="cuotas-info">
          <div className="cuotas-info-row">
            <FontAwesomeIcon icon={faPrint} className="cuotas-info-icon" />
            <span>
              Podés imprimir tu talón y abonarlo en las entidades de pago
              habilitadas:
            </span>
            <div className="cuotas-pago-logos">
              <img src={ImageRapiPago} alt="Rapi Pago" />
              <img src={ImagePagoMisCuentas} alt="Pago Mis Cuentas" />
              <img src={ImageProvinciaNet} alt="Provincia NET" />
            </div>
          </div>
          <div className="cuotas-info-row">
            <FontAwesomeIcon icon={faCreditCard} className="cuotas-info-icon" />
            <span>
              Podés abonar online seleccionando los talones a pagar y haciendo
              click en el botón de <strong>PAGO ONLINE</strong>.
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* Banner promocional: se muestra según PM_BANNER_PROMO ("S") del backend. */}
      {showBanner && <PromoBanner />}

      <div className="cuotas-toolbar">
        <label htmlFor="ver-cuotas">Ver</label>
        <select
          id="ver-cuotas"
          className="form-select"
          onChange={handleChangeFilter}
          value={optionFilter}
        >
          <option value="pendientes">Cuotas Pendientes</option>
          <option value="pagadas">Historial de Pagos</option>
          <option value="todas">Todos</option>
        </select>
      </div>
      {onLoad ? (
        <SkeletonTable />
      ) : (
        <div className="cuotas-scroll">
        <section className="section-cuota-y-pago">
          <div className="d-header-cuotas-y-pago-all">
            <span>Pago Online</span>
            <span>Talon</span>
            <span>Concepto</span>
            <span>1° Vencimiento</span>
            <span>1° Importe</span>
            <span>2° Vencimiento</span>
            <span>2° Importe</span>
            <span>Seña</span>
            <span>Pagado</span>
            <span>Vencido</span>
            <span style={{ maxWidth: "9em" }}>Imprimir</span>
          </div>
          <div className="d-grid-title">
            <span>Pago Online</span>
            <span>Talon</span>
            <span>Importe</span>
            <span>Pagado</span>
            <span></span>
          </div>
          {cuotasFilter.map((cuota: ICuota) => (
            <div className={`d-grid-cuotas-y-pago`} key={cuota.NU_TALON}>
              <div
                onClick={() => showCuota(cuota.NU_TALON)}
                className={`d-grid-title cursor-pointer ${
                  !cuota.D_PAGO && cuota.D_VENCIDO
                    ? "bg-danger"
                    : "bg-dark-platform"
                }`}
              >
                <span>
                  {+cuota.IMP_PAGAR > 0 ? (
                    // Checkbox para seleccionar el talón directo desde la fila
                    // colapsada (mobile), sin tener que abrir el detalle.
                    // stopPropagation: tildar no debe expandir la fila.
                    <input
                      type="checkbox"
                      name={cuota.NU_TALON.toString()}
                      checked={cuotasPagar.some(
                        (c) => c.NU_TALON === cuota.NU_TALON
                      )}
                      onChange={handleTogleCuota}
                      onClick={(e) => e.stopPropagation()}
                    />
                  ) : cuota.CLAVE_EMISION ? (
                    "Si"
                  ) : (
                    " "
                  )}
                </span>
                <span>{cuota.NU_TALON}</span>
                <span>{cuota.MONEDA + cuota.D_IMPORTE}</span>
                <span
                  className={
                    cuota.D_PAGO
                      ? "text-success text-center"
                      : "text-danger text-center"
                  }
                >
                  {cuota.D_PAGO ? "✓" : "X"}
                </span>
                <span>
                  <FontAwesomeIcon
                    className={cuota.show ? "r-90" : ""}
                    icon={faChevronDown}
                  />
                </span>
              </div>
              <div className={`d-grid-header  ${cuota.show ? "show" : ""}`}>
                <div>Pago Online</div>
                <div>Talon</div>
                <div>Concepto</div>
                <div>1° Vencimiento</div>
                <div>1° Importe</div>
                <div>2° Vencimiento</div>
                <div>2° Importe</div>
                <div>Seña</div>
                <div>Pagado</div>
                <div>Vencido</div>
                <div style={{ minHeight: "3em" }}>Imprimir</div>
              </div>
              <div
                className={`d-grid-body ${cuota.show ? "show" : ""} ${
                  !cuota.D_PAGO && cuota.D_VENCIDO ? "bg-danger text-white" : ""
                }`}
              >
                <div className="container-checkbox-container-pago-online">
                  {+cuota.IMP_PAGAR > 0 && (
                    <div className="checkbox-container-pago-online d-flex justify-content-center pt-2">
                      <input
                        name={cuota.NU_TALON.toString()}
                        checked={cuotasPagar.some(
                          (c) => c.NU_TALON === cuota.NU_TALON
                        )}
                        onChange={handleTogleCuota}
                        type="checkbox"
                      />
                    </div>
                  )}
                  {cuota.IMP_TRANSFERIR > 0 && (
                    <Button
                      onPress={() => setCuotaInformarPago(cuota)}
                      title="Informar pago"
                    />
                  )}
                </div>
                <div>{cuota.NU_TALON}</div>
                <div>{cuota.CONCEPTO}</div>
                <div>{cuota.D_PRI_VEN}</div>
                <div
                  className={
                    cuota.D_PAGO
                      ? "text-success"
                      : cuota.D_VENCIDO
                      ? "text-danger"
                      : ""
                  }
                >
                  {cuota.MONEDA + cuota.D_IMPORTE}
                </div>
                <div>{cuota.D_SEG_VEN}</div>
                <div>{cuota.MONEDA + cuota.D_IMPORTE2}</div>
                <div>
                  {cuota.D_SEN !== "0" ? cuota.MONEDA + cuota.D_SEN : ""}
                </div>
                <div
                  className={
                    cuota.D_PAGO
                      ? "text-success text-center"
                      : "text-danger text-center"
                  }
                >
                  {cuota.D_PAGO ? "✓" : "X"}
                </div>
                <div className="text-danger text-center">
                  {cuota.D_VENCIDO ? "Si" : "."}
                </div>
                <div
                  style={{ minHeight: "3em", maxWidth: "9em" }}
                  className="text-center py-1"
                >
                  {cuota.BOTON_ACTUALIZAR ? (
                    <Link to={`/pasajero/${id}/${nombre}/cuotas/actualizar`}>
                      <Button title="Actualizar" onPress={() => {}} />
                    </Link>
                  ) : (
                    <></>
                  )}
                  {cuota.NU_FACTURA ? (
                    <Button
                      icon={faFilePdf}
                      onLoad={cuota.onImprimirFactura}
                      title={cuota.NU_FACTURA}
                      onPress={() =>
                        handleClickImprimirFactura(cuota.NU_FACTURA)
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {cuota.CLAVE_EMISION && (
                    <Button
                      title="imprimir"
                      onLoad={printing}
                      onPress={() => handleClickImprimir(cuota.NU_TALON)}
                    />
                  )}
                </div>
              </div>
              {cuota.mensaje && cuota.mensaje.trim() !== "" && (
                <div dangerouslySetInnerHTML={{ __html: cuota.mensaje }}></div>
              )}
            </div>
          ))}
        </section>
        </div>
      )}
      <BarraPagoFlotante
        importe={importePagar}
        onPagar={handleAbrirMedios}
        onCancelar={() => setCuotasPagar([])}
      />
      <ModalMediosPago
        show={showMetodoPago}
        onClose={handleCerrarMedios}
        modalidades={pago.modalidades}
        loadingModalidades={pago.loadingModalidades}
        payingToken={pago.payingToken}
        error={pago.error}
        onSelectModalidad={handleSelectModalidad}
      />
      <ModalInformarPago
        id={id}
        cuota={cuotaInformarPago}
        show={!!cuotaInformarPago}
        onClose={() => setCuotaInformarPago(null)}
      />
    </div>
  );
}
